import { render } from "./alertbar.vue?vue&type=template&id=0a8fe70d&scoped=true"
import script from "./alertbar.vue?vue&type=script&lang=js"
export * from "./alertbar.vue?vue&type=script&lang=js"

import "./alertbar.vue?vue&type=style&index=0&id=0a8fe70d&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a8fe70d"]])

export default __exports__